import { RegularButton } from 'fronton-react';
import { PlusIcon } from '@fronton/icons-react';
import React from 'react';
import { ButtonWrapperForIntegration } from './button-wrapper-for-integration';
import { buttonClass } from './styles';

type TProps = {
  openChooseColorModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  dataForIntegration: string;
  isTintAvailable: boolean;
};

export const ChooseColorButton = ({ dataForIntegration, openChooseColorModal, isTintAvailable }: TProps) => (
  <ButtonWrapperForIntegration
    dataQa="select-tint-color-general-button"
    dataForIntegration={dataForIntegration}
    openChooseColorModal={openChooseColorModal}
    isTintAvailable={isTintAvailable}>
    <RegularButton
      data-testid="select-tint-color-button"
      rounded
      iconLeft={<PlusIcon />}
      size="m"
      variant="accent"
      className={buttonClass}>
      Заколеровать
    </RegularButton>
  </ButtonWrapperForIntegration>
);
